import { render, staticRenderFns } from "./CrimeDetails.vue?vue&type=template&id=958961e8"
import script from "./CrimeDetails.vue?vue&type=script&lang=js"
export * from "./CrimeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports